// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your components/pages

import Login from "./Components/Login/Login";
import { AuthProvider } from "./Components/AuthContext/Authcontext";
import LeadForm from "./LeadForm";
import LeadsTable from "./LeadTable";
import AdminLeads from "./Components/Pages/Admin/Lead/Leads";
import AddLeadForm from "./Components/Pages/Admin/Lead/Addleads/Addleads";
import TeamMembers from "./Components/Pages/Admin/AllTeams/TeamMembersTable";
import AdminEditEmployee from "./Components/Pages/Admin/AllTeams/EditEmployee/EditEmployee";
import AddEmployeeModal from "./Components/Pages/Admin/AllTeams/AddEmployeeModal";
import AllTeams from "./Components/Pages/Admin/AllTeams/AllTeams";
import Product from "./Product";
import QuotationForm from "./Quotation";
import SampleLead from "./Components/Pages/Admin/Sample/SampleLead";
import SampleQuotation from "./Components/Pages/Admin/Sample/SampleQuotation";
import ManagerLeads from "./Components/Pages/Manager/Lead/Leads";
import ManagerAddLeadForm from "./Components/Pages/Manager/Lead/Addleads/Addleads";
import AssociateLeads from "./Components/Pages/Associate/Lead/Leads";
import AssociateAddLeadForm from "./Components/Pages/Associate/Lead/Addleads/Addleads";
import Dashboard from "./Components/Pages/Admin/Dashboard/Dashboard";
import ManagerDashboard from "./Components/Pages/Manager/Dashboard/Dashboard";
import AssociateDashboard from "./Components/Pages/Associate/Dashboard/Dashboard";
import ViewLead from "./Components/Pages/Admin/Lead/ViewLeads/ViewLead";
import S_comments from "./Components/Pages/Associate/Lead/Comment/LeadsComments";
import M_Comments from "./Components/Pages/Manager/Lead/Comment/LeadsComments";
import A_CommentsPage from "./Components/Pages/Admin/Lead/Comment/LeadsComments";
import A_ViewLeads from "./Components/Pages/Admin/Lead/ViewLead/InDetailViewLeads";
import M_ViewLead from "./Components/Pages/Manager/Lead/ViewLeads/ViewLeads";
import S_ViewLead from "./Components/Pages/Associate/Lead/ViewLeads/ViewLeads";
import QuotationPreview from "./Components/Pages/Admin/Sample/QuotationPreview";
import ViewQuotationPreview from "./Components/Pages/Admin/Lead/ViewLeads/ViewQuotationPreview";
import AdminOppLeads from "./Components/Pages/Admin/Opportunity/Opportunity";
import ManagerOppLeads from "./Components/Pages/Manager/Opporunity/ManagerOppLeads";
import AssociateOppLeads from "./Components/Pages/Associate/Opportunity/AssociateOppLeads";
import ViewSentQuotations from "./Components/Pages/Admin/Lead/ViewLeads/ViewSentQuotations";
import Dashboard_old from "./Components/Pages/Admin/Dashboard/Dashboard_old";
import ViewSentPDFPreview from "./Components/Pages/Admin/Sample/ViewSentPDFPreview";
import Quotation2 from "./Components/Pages/Admin/Tharun/Quotation2";
import MailTester from "./Components/Mail/MailTester";
import M_ViewQuotationPreview from "./Components/Pages/Manager/Lead/ViewLeads/ViewQuotationPreview";
import M_QuotationPreview from "./Components/Pages/Manager/Lead/ViewLeads/QuotationPDFPreview";
import M_ViewSentQuotations from "./Components/Pages/Manager/Lead/ViewLeads/ViewSentQuotations";
import M_ViewSentPDFPreview from "./Components/Pages/Manager/Lead/ViewLeads/ViewSentPDFPreview";
import S_ViewQuotationPreview from "./Components/Pages/Associate/Lead/ViewLeads/ViewQuotationPreview";
import S_QuotationPreview from "./Components/Pages/Associate/Lead/ViewLeads/QuotationPDFPreview";
import S_ViewSentQuotations from "./Components/Pages/Associate/Lead/ViewLeads/ViewSentQuotations";
import S_ViewSentPDFPreview from "./Components/Pages/Associate/Lead/ViewLeads/ViewSentPDFPreview";
import S_RawEmailPage from "./Components/Pages/Associate/Lead/ViewLeads/RawEmail";
import M_RawEmailPage from "./Components/Pages/Manager/Lead/ViewLeads/RawEmail";
import RawEmailPage from "./Components/Pages/Admin/Lead/ViewLeads/RawEmail";
import LoginPage from "./Loginpage";
import S_DynamicForm from "./Components/Pages/Associate/Lead/Addleads/Addleads";
import M_DynamicForm from "./Components/Pages/Manager/Lead/Addleads/Addleads";
import NewLeadView from "./Components/Pages/Admin/Lead/NewLeads/NewLeadView";
import M_NewLeadView from "./Components/Pages/Manager/Lead/NewLeads/NewLeadView";
import S_NewLeadView from "./Components/Pages/Associate/Lead/NewLeads/NewLeadView";
import BudgetQuotationForm from "./Components/Pages/Admin/Lead/BudgetForm";

import Email_new from "./Components/QuotationEmail/Email_new"
import AssociateRegretEmail from "./Components/AssociateRegretEmail/RegretEmail"
import ManagerRegretEmail from "./Components/ManagerRegretEmail/RegretEmail"
import AdminRegretEmail from "./Components/AdminRegretEmail/RegretEmail"

import Followuppage from "./Components/Pages/Admin/Lead/FollowUp/Followuppage";
import S_Followuppage from "./Components/Pages/Associate/Lead/FollowUp/Followuppage";
import M_Followuppage from "./Components/Pages/Manager/Lead/FollowUp/Followuppage";
import Quotationpage from "./Components/Pages/Admin/Quotation/Quotationpage";
import Previewquotationpage from './Components/Pages/Admin/Quotation/Previewquotationpage';
import Company from "./Components/Pages/Admin/company/Company";


import M_Quotationpage from "./Components/Pages/Manager/Quotation/Quotationpage";
import M_Previewquotationpage from './Components/Pages/Manager/Quotation/Previewquotationpage';

import S_Quotationpage from "./Components/Pages/Associate/Quotation/Quotationpage";
import S_Previewquotationpage from './Components/Pages/Associate/Quotation/Previewquotationpage';
import Opportunityview from "./Components/Pages/Admin/View-Edit/Opportunityview";
import S_Opportunityview from "./Components/Pages/Associate/View-Edit/Opportunityview";
import M_Opportunityview from "./Components/Pages/Manager/View-Edit/Opportunityview"
import Leadview from "./Components/Pages/Admin/View-Edit/Leadview";
import SalesManagerOppLeads from "./Components/Pages/Manager/Opporunity/SalesManagerOppLeads";
import SalesManagerLeads from "./Components/Pages/Manager/Lead/SalesLeads";
import SalesAssociateOppLeads from "./Components/Pages/Associate/Opportunity/SalesAssociateOppLeads";
import SalesAssociateLeads from "./Components/Pages/Associate/Lead/SalesLeads";
import EmailHistory from "./Components/Pages/Associate/Mailhistory/Emailhistory";
import M_EmailHistory from "./Components/Pages/Manager/Opporunity/EmailHistory";
import A_EmailHistory from "./Components/Pages/Admin/Opportunity/EmailHistory";


function App() {
  return (
    <AuthProvider>
      <Router>
        {/* Navbar always visible */}


        {/* Routes */}
        <Routes>
          {/* <Route path="/" element={<Navbar />} /> */}
          <Route path="/" element={<Login />} />
          <Route path="/a-add-lead" element={<AddLeadForm />} />
          <Route path="/s-add-lead" element={<S_DynamicForm />} />
          <Route path="/m-add-lead" element={<M_DynamicForm />} />
          <Route path="/leadform" element={<LeadForm />} />
          <Route path="/leadtable" element={<LeadsTable />} />
          <Route path="/adminleads" element={<AdminLeads />} />
          <Route path="/a-allteams" element={<AllTeams />} />
          <Route path="/addemployee" element={<AddEmployeeModal />} />
          <Route path="/team-members" element={<TeamMembers />} />
          <Route path="/editemployee/:id" element={<AdminEditEmployee />} />

          <Route path="/send-budget" element={<BudgetQuotationForm />} />

          <Route path="/adminoppleads" element={<AdminOppLeads />} />


          <Route path="/managerleadforms" element={<ManagerAddLeadForm />} />
          <Route path="/managerleads" element={<ManagerLeads />} />
          <Route path="/manageroppleads" element={<ManagerOppLeads />} />
          <Route path="/associateleadforms" element={<AssociateAddLeadForm />} />
          <Route path="/associateleads" element={<AssociateLeads />} />
          <Route path="/associateoppleads" element={<AssociateOppLeads />} />

          <Route path="/a-dashboard" element={<Dashboard />} />
          <Route path="/m-dashboard" element={<ManagerDashboard />} />
          <Route path="/s-dashboard" element={<AssociateDashboard />} />

          <Route path="/s-comments/:leadid" element={<S_comments />} />
          <Route path="/s-opp-comments/:leadid" element={<S_comments />} />
          <Route path="/m-comments/:leadid" element={<M_Comments />} />
          <Route path="/m-opp-comments/:leadid" element={<M_Comments />} />
          <Route path="/a-comments/:leadid" element={<A_CommentsPage />} />
          <Route path="/a-opp-comments/:leadid" element={<A_CommentsPage />} />


          <Route path="/a-view-lead/:leadid" element={<A_ViewLeads />} />

          <Route path="/Product" element={<Product />} />
          <Route path="/quotation" element={<QuotationForm />} />
          <Route path="/sample-lead" element={<SampleLead />} />
          <Route path="/sample-quotation" element={<SampleQuotation />} />
          <Route path="/view-lead/:id" element={<ViewLead />} />
          <Route path="/m-view-lead/:id" element={<M_ViewLead />} />
          <Route path="/s-view-lead/:id" element={<S_ViewLead />} />
          <Route path="/old_dashboard" element={<Dashboard_old />} />
          <Route path="/quotation-preview" element={<QuotationPreview />} />
          <Route path="/m-quotation-preview" element={<M_QuotationPreview />} />
          <Route path="/s-quotation-preview" element={<S_QuotationPreview />} />
          <Route path="/view-quotation" element={<ViewQuotationPreview />} />
          <Route path="/m-view-quotation" element={<M_ViewQuotationPreview />} />
          <Route path="/s-view-quotation" element={<S_ViewQuotationPreview />} />



          <Route path="/view-sent-quotations/:leadId" element={<ViewSentQuotations />} />
          <Route path="/m-view-sent-quotations/:leadId" element={<M_ViewSentQuotations />} />
          <Route path="/s-view-sent-quotations/:leadId" element={<S_ViewSentQuotations />} />
          <Route path="/a-opp-view-sent-quotations/:leadId" element={<ViewSentQuotations />} />
          <Route path="/m-opp-view-sent-quotations/:leadId" element={<M_ViewSentQuotations />} />
          <Route path="/s-opp-view-sent-quotations/:leadId" element={<S_ViewSentQuotations />} />
          <Route path="/sent-quotations-view" element={<ViewSentPDFPreview />} />
          <Route path="/m-sent-quotations-view" element={<M_ViewSentPDFPreview />} />
          <Route path="/s-sent-quotations-view" element={<S_ViewSentPDFPreview />} />
          <Route path="/tharun-quotation" element={<Quotation2 />} />

          <Route path="/mail" element={<MailTester />} />
          <Route path="/s-raw-mail/:id" element={<S_RawEmailPage />} />
          <Route path="/m-raw-mail/:id" element={<M_RawEmailPage />} />
          <Route path="/raw-mail/:id" element={<RawEmailPage />} />
          <Route path="/loginpage" element={<LoginPage />} />
          <Route path="/a-newviewlead/:id" element={<NewLeadView />} />
          <Route path="/m-newviewlead/:id" element={<M_NewLeadView />} />
          <Route path="/s-newviewlead/:id" element={<S_NewLeadView />} />


        <Route path="/email" element={<Email_new />} />
        <Route path="/s-regret-email/:leadid" element={<AssociateRegretEmail />} />
        <Route path="/m-regret-email/:leadid" element={<ManagerRegretEmail />} />
         <Route path="/regret-email/:leadid" element={<AdminRegretEmail />} />

        <Route path="/a-followup/:leadid" element={<Followuppage />} />    
        <Route path="/s-followup/:leadid" element={<S_Followuppage />} />  
        <Route path="/m-followup/:leadid" element={<M_Followuppage />} />  
        <Route path="/quotationpage" element={<Quotationpage />} />

          {/* <Route path="/email" element={<Email_new />} /> */}
          {/* <Route path="/s-regret-email/:leadid" element={<RegretEmail />} /> */}

          {/* <Route path="/a-followup/:leadid" element={<Followuppage />} /> */}
          <Route path="/a-opp-followup/:leadid" element={<Followuppage />} />

          {/* <Route path="/s-followup/:leadid" element={<S_Followuppage />} /> */}
          <Route path="/s-opp-followup/:leadid" element={<S_Followuppage />} />
          {/* <Route path="/m-followup/:leadid" element={<M_Followuppage />} /> */}
          <Route path="/m-opp-followup/:leadid" element={<M_Followuppage />} />
          <Route path="/quotationpage" element={<Quotationpage />} />
          <Route path="/previewquotation/:id" element={<Previewquotationpage />} />
          <Route path="/company" element={<Company />} />



          <Route path="/m-quotationpage" element={<M_Quotationpage />} />
          <Route path="/m-previewquotation/:id" element={<M_Previewquotationpage />} />

          <Route path="/s-quotationpage" element={<S_Quotationpage />} />
          <Route path="/s-previewquotation/:id" element={<S_Previewquotationpage />} />
          <Route path="/opportunity_view/:id"  element={<Opportunityview />} />

          <Route path="/s-opportunity_view/:id"  element={<S_Opportunityview />} />
          <Route path="/m-opportunity_view/:id"  element={<M_Opportunityview />} />
          <Route path="/lead_view/:id"  element={<Leadview />} />
          <Route path="/sales-manageroppleads" element={<SalesManagerOppLeads />} />
          <Route path="/sales-managerleads" element={<SalesManagerLeads />} />
          <Route path="/sales-associateoppleads" element={<SalesAssociateOppLeads />} />
          <Route path="/sales-associateleads" element={<SalesAssociateLeads />} />
          <Route path="/s-send-email/:leadid" element={<EmailHistory />} />
          <Route path="/m-send-email/:leadid" element={<M_EmailHistory />} />
          <Route path="/a-send-email/:leadid" element={<A_EmailHistory />} />
          


        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
